<template>
  <div class="login">
    <div class="login_school_icon">
      <img src="../assets/imgs/loginSchoolIcon.png" alt="" width="100%" />
    </div>
    <div class="login_systmeName">北师大实验国际部简历系统</div>
    <div class="login_form">
      <div class="login_form_title">登录</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="94px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="手机号：" prop="eduId">
          <el-input v-model="ruleForm.eduId"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="validateCode" class="validateCode">
          <el-input v-model="ruleForm.validateCode"></el-input>
          <div class="codeImg" @click="getImgCode">
            <img :src="imageVerifyUrl" alt="" width="100%" height="100%" />
          </div>
        </el-form-item>
        <el-form-item class="operate">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            class="purple"
            :disabled="loginDisable"
            >登录</el-button
          >
          <el-button @click="register" class="default">注册</el-button>

          <div class="forgetPassword"  @click="forgotPassword">忘记密码？</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form, FormItem, Input, Button, Message } from "element-ui";
Vue.use(Form).use(FormItem).use(Input).use(Button);

export default {
  name: "login",
  data() {
    return {
      ruleForm: {
        eduId: "",
        password: "",
        validateCode: "",
      },
      rules: {
        eduId: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      imageVerifyToken: "",
      imageVerifyUrl: "",
      loginDisable: false,
    };
  },
  methods: {
    submitForm(form) {
      const that = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.loginDisable = true;
          that.ruleForm.validateToken = that.imageVerifyToken;
          that.$axios
            .post(
              "/galaxy/baoming/api/v1/huaxia/applicant/login",
              that.ruleForm
            )
            .then((result) => {
              const res = result.data;
              if (
                result.code === "1000000" &&
                res &&
                JSON.stringify(res) !== "{}"
              ) {
                Message({
                  type: "success",
                  message: "登录成功,即将跳转",
                  duration: 800,
                  onClose() {
                    that.$router.push({
                      name: "PersonalMessage",
                      query: {
                        applicationId: res.applicationId || "",
                        applicantToken: res.applicantToken,
                        batchState: res.batchState,
                        fillEnable: res.fillEnable ? 1 : 0,
                      },
                    });
                  },
                });
              } else {
                that.getImgCode();
                that.loginDisable = false;
              }
            })
            .catch((err) => {
              console.log(err);
              that.loginDisable = false;
            });
        }
      });
    },
    forgotPassword() {
      this.$router.push({
        path: "/forgotPassword",
      });
    },
    register() {
      this.$router.push({
        path: "/register",
      });
    },
    // 获取图形验证码
    getImgCode() {
      this.$axios
        .get(`/galaxy/baoming/api/v1/huaxia/applicant/generateValidateCode`)
        .then((result) => {
          const res = result.data;
          if (
            result.code === "1000000" &&
            res &&
            JSON.stringify(res) !== "{}"
          ) {
            this.imageVerifyToken = res.imageVerifyToken;
            this.imageVerifyUrl = res.url;
          } else {
            this.imageVerifyToken = "";
            this.imageVerifyUrl = "";
          }
        });
    },
  },
  created() {
    this.getImgCode();
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: #edf3f7;
  padding-top: 4%;
  .login_school_icon {
    width: 30%;
    // width: 629px;
    // height: 123px;
    margin: 0 auto 20px;
    // background-image: url('../assets/imgs/loginSchoolIcon.png');
  }
  .login_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }
  .login_form {
    width: 486px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 20px 36px;
    border-radius: 10px;
    .login_form_title {
      font-size: 24px;
      color: #353535;
      margin-bottom: 24px;
    }
  }
}
</style>
<style lang="scss">
.login_form {
  .forgetPassword {
    font-family: Microsoft YaHei UI;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: left;
    color: rgba(24, 144, 255, 1);
    margin-top: 8px;
    cursor: pointer;
  }
  .el-form-item__label {
    color: rgba(0, 0, 0, 0.85);
  }
  .el-input {
    height: 32px;
    line-height: 32px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .validateCode {
    .codeImg {
      float: right;
      width: 90px;
      height: 32px;
      background-color: rgba(226, 134, 148, 1);
      margin-top: 0px;
      cursor: pointer;
    }
    .el-input {
      float: left;
      width: 220px;
      .el-input__inner {
        width: 220px;
      }
    }
  }
  .operate {
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-button {
      width: 198px;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .purple {
    background-color: #1890ff !important;
    border-color: #1890ff !important;
    &:hover {
      background-color: #1890ff;
      border-color: #1890ff;
      color: #fff;
    }
  }
  .default:hover {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
}
</style>
